import { useEffect } from 'react';
import { Crisp } from 'crisp-sdk-web';
import { CRISP_CONFIG, type CrispEventName } from '@/config/crisp';

export const useCrisp = () => {
  useEffect(() => {
    // Initialiser Crisp seulement côté client
    if (typeof window !== 'undefined' && CRISP_CONFIG.WEBSITE_ID) {
      Crisp.configure(CRISP_CONFIG.WEBSITE_ID);
    }
  }, []);

  const openChat = () => {
    if (typeof window !== 'undefined') {
      Crisp.chat.open();
    }
  };

  const closeChat = () => {
    if (typeof window !== 'undefined') {
      Crisp.chat.close();
    }
  };

  const pushEvent = (eventName: CrispEventName | string, data?: any) => {
    if (typeof window !== 'undefined') {
      Crisp.session.pushEvent(eventName, data);
    }
  };

  const setUserData = (userData: {
    email?: string;
    nickname?: string;
    phone?: string;
    avatar?: string;
  }) => {
    if (typeof window !== 'undefined') {
      if (userData.email) Crisp.user.setEmail(userData.email);
      if (userData.nickname) Crisp.user.setNickname(userData.nickname);
      if (userData.phone) Crisp.user.setPhone(userData.phone);
      if (userData.avatar) Crisp.user.setAvatar(userData.avatar);
    }
  };

  return {
    openChat,
    closeChat,
    pushEvent,
    setUserData
  };
};